<template>
  <v-select
    v-model="mallProxy"
    :items="mallsList"
    :label="label"
    :hint="hint"
    :error-messages="errorMessages"
    persistent-hint
    item-text="name"
    return-object
    :outlined="outline"
    color="primary"
    ref="mall-select"
    value="id"
    :disabled="disabled"
    :clearable="clearable"
  >
  </v-select>
</template>

<script>
import MallService from '@/services/malls'
export default {
  name: 'MallSelector',
  props: {
    outline: {type: Boolean, required: false},
    value: {required: true},
    label: {type: String, required: false, default: ''},
    hint: {type: String, required: false, default: ''},
    errorMessages: {type: Array, required: false, default: () => []},
    disabled: {type: Boolean, required: false},
    clearable: {type: Boolean, required: false}
  },
  data: () => ({
    mallsList: []
  }),
  computed: {
    mallProxy: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  async created () {
    this.mallsList = await MallService.getAll()
  }
}
</script>